import React from 'react';
import { connect } from 'react-redux';
// By some funky reason, Router must be there. Otherwise, it doesn't work!
// eslint-disable-next-line no-unused-vars
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';

/**
 * This auth flow is same as the one described in the React Router docs, see:
 * {@link https://reacttraining.com/react-router/web/example/auth-workflow}
 */
const PrivateRoute = ({
  component: Component,
  isLoggedIn,
  ifLoggedInShouldRedirectTo,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (isLoggedIn) {
        if (ifLoggedInShouldRedirectTo) {
          const redirectTo = {
            pathname: ifLoggedInShouldRedirectTo,
            state: { from: props.location },
          };

          return <Redirect to={redirectTo} />;
        }

        return <Component {...props} />;
      }

      const redirectTo = {
        pathname: '/login',
        state: { from: props.location },
      };

      return <Redirect to={redirectTo} />;
    }}
  />
);

const mapStateToProps = ({ auth }) => ({
  isLoggedIn: !!(auth.data && auth.data.token),
});

export default connect(
  mapStateToProps,
  null,
  null,
  // In order to connect the PrivateRoute react router component with Redux,
  // without breaking it, {@link https://stackoverflow.com/a/44565657/1333836}
  { pure: false }
)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/core/routing/PrivateRoute.js